// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"ecc7a656","453":"2c9696b2"}[chunkId] + ".chunk.js";
};